import { rem } from 'polished';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Event, BigPictureClient } from '@vimeo/bigpicture-client';
import { translate } from '@vimeo/i18n-runtime';
import { Modal } from '@vimeo/iris/components';
import { Paragraph } from '@vimeo/iris/typography';
import { LoginJoinModal } from '@vimeo/ui/core';

interface Props {
  xsrft: string;
  albumId: number;
}

const OfComLoginModal = ({ xsrft, albumId }: Props) => {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const event = new Event('vimeo.content_rating_block', 2, {
      product: 'Distribution',
      path: location.pathname,
      collection_id: albumId,
      collection_type: 'showcase',
      video_id: null,
      content_rating: null,
    });
    BigPictureClient.sendEvent(event);
  }, [albumId]);

  return (
    <LoginJoinModal
      type="login"
      xsrft={xsrft}
      onDismiss={() => setIsActive(true)}
      onSuccess={() => window.location.reload()}
    >
      {(toggleModal) => (
        <Modal
          active={isActive}
          content={
            <ModalStyled>
              <Modal.Header>{translate('Log in to watch')}</Modal.Header>
              <Paragraph size="2">
                {translate(
                  'This collection contains unrated or mature content. Please log in to watch.',
                )}
              </Paragraph>
              <ModalFooter>
                <Modal.PrimaryAction
                  onClick={() => {
                    toggleModal();
                    setIsActive(false);
                  }}
                >
                  {translate('Log in')}
                </Modal.PrimaryAction>
              </ModalFooter>
            </ModalStyled>
          }
        />
      )}
    </LoginJoinModal>
  );
};

const ModalFooter = styled(Modal.Footer)`
  border-top: 0;
`;

const ModalStyled = styled.div`
  padding: ${rem(32)};
  border-radius: ${rem(4)};
  background: ${({ theme }) => theme.content.background};
`;

export default OfComLoginModal;
